import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'

Vue.use(Router)

export const constantRouterMap = [
  { path: '/faInspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/faInspectionApp'], resolve),
    hidden: true
  },
  { path: '/mwInspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/mwInspectionApp'], resolve),
    hidden: true
  },
  { path: '/gbInspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/gbInspectionApp'], resolve),
    hidden: true
  },
  { path: '/dlInspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/dlInspectionApp'], resolve),
    hidden: true
  },
  { path: '/hmInspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/hmInspectionApp'], resolve),
    hidden: true
  },
  { path: '/inspectionApp',
    meta: { title: '管理工具下载', noCache: true },
    component: (resolve) => require(['@/views/download/inspectionApp'], resolve),
    hidden: true
  },
  { path: '/activity',
    meta: { title: '智慧停车统计', noCache: true },
    component: (resolve) => require(['@/views/activity/index'], resolve),
    hidden: true
  },
  { path: '/pdaScanQrcode',
    meta: { title: '扫码支付', noCache: true },
    component: (resolve) => require(['@/views/wechat/pdaScanQrcode'], resolve),
    hidden: true
  },
  { path: '/scanGroupCardQrcode',
    meta: { title: '集团卡', noCache: true },
    component: (resolve) => require(['@/views/wechat/scanGroupCardQrcode'], resolve),
    hidden: true
  },
  { path: '/groupCardInfo',
    meta: { title: '集团卡详情', noCache: true },
    component: (resolve) => require(['@/views/wechat/groupCardInfo'], resolve),
    hidden: true
  },
  { path: '/scanSpeialBillQrcode',
    meta: { title: '扫码支付', noCache: true },
    component: (resolve) => require(['@/views/wechat/scanSpeialBillQrcode'], resolve),
    hidden: true
  },
  { path: '/speialBillInfo',
    meta: { title: '扫码支付-详情', noCache: true },
    component: (resolve) => require(['@/views/wechat/speialBillInfo'], resolve),
    hidden: true
  },
  { path: '/scanQRcode',
    meta: { title: '扫码出场', noCache: true },
    component: (resolve) => require(['@/views/wechat/scanQrcode'], resolve),
    hidden: true
  },
  { path: '/orderInfoByQRcode',
    meta: { title: '扫码出场-订单详情', noCache: true },
    component: (resolve) => require(['@/views/wechat/orderInfo'], resolve),
    hidden: true
  },
  { path: '/palyer',
    meta: { title: '监控视频', noCache: true },
    component: (resolve) => require(['@/views/parking/cloudSentryBox/palyer'], resolve),
    hidden: true
  },
  { path: '/login',
    meta: { title: '登录', noCache: true },
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/features/404'], resolve),
    hidden: true
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/features/401'], resolve),
    hidden: true
  },
  {
    path: '/dataView',
    component: (resolve) => require(['@/views/bigScreen/dataView'], resolve),
    hidden: true
  },
  {
    path: '/newDataView',
    component: (resolve) => require(['@/views/bigScreen/newDataView'], resolve),
    hidden: true
  },
  {
    path: '/spaceDataView',
    component: (resolve) => require(['@/views/bigScreen/spaceDataView'], resolve),
    hidden: true
  },
  {
    path: '/operationView',
    component: (resolve) => require(['@/views/bigScreen/operationView'], resolve),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        meta: { noCache: true },
        component: (resolve) => require(['@/views/features/redirect'], resolve)
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    hidden: true,
    // redirect: '/dashboard',
    // children: [
    //   {
    //     path: 'dashboard',
    //     component: (resolve) => require(['@/views/home'], resolve),
    //     name: 'Dashboard',
    //     meta: { title: '首页', icon: 'index', affix: true, noCache: true }
    //   }
    // ]
  },
  {
    path: '/parkingSetting', // "车位管理"
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: '/parkingAdmin/add/:id',
        component: (resolve) => require(['@/views/parking/components/add'], resolve),
        name: '新增车位',
        meta: { title: '新增车位' }
      }
    ]
  },
  {
    path: '/OrderManagement',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'parkingRecordOrderInfo/:id',
        component: (resolve) => require(['@/views/parkingOperations/parkingrecordorder/components/info'], resolve),
        name: '停车订单详情',
        meta: { title: '停车订单详情' }
      }
    ]
  },
  {
    path: '/jointRecovery',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'unpaidOrders/:id',
        component: (resolve) => require(['@/views/jointRecovery/unpaidOrders/components/OrderDetail'], resolve),
        name: '追缴订单详情',
        meta: { title: '追缴订单详情' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'center',
        component: (resolve) => require(['@/views/system/user/center'], resolve),
        name: '个人中心',
        meta: { title: '个人中心' }
      }
    ]
  }
]

export default new Router({
//   mode: 'history',
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
